import { useTranslation } from "react-i18next";
import { Box, Flex } from "rebass/styled-components";

import { Headline } from "../../../Components/Text";
import { DividerAlt } from "../../../Components/Divider";
import { LinkDiscord } from "./LinkDiscord";
import { LinkFaceit } from "./LinkFaceit";
import { LinkTikTok } from "./LinkTikTok";
import { LinkSteam } from "./LinkSteam";
import { LinkBattleNet } from "./LinkBattleNet";
import { Error } from "../../../../components/atoms/form/error";
import { Success } from "../../../Components/Inputs";
import { useOauthStateAndCleanup } from "../../../Hooks/useResetOauthState";
import { LinkRiot } from "./LinkRiot";
import { LinkEpic } from "./LinkEpic";

const LinkedAccounts = () => {
  const { successMessage, errorMessage } = useOauthStateAndCleanup();
  const { t } = useTranslation("translation", {
    keyPrefix: "account.connected",
  });

  const translatedButtonText = t("linkYour");

  return (
    <Box variant={"settingsContainer"} mb={25}>
      <Headline>{t("connectedAccounts")}</Headline>
      <DividerAlt />
      <Flex width="100%">
        {errorMessage && <Error width="100%">{errorMessage}</Error>}
        {successMessage && <Success width="100%">{successMessage}</Success>}
      </Flex>
      <LinkDiscord buttonText={`${translatedButtonText} Discord`} />
      <LinkFaceit buttonText={`${translatedButtonText} FACEIT`} />
      <LinkTikTok buttonText={`${translatedButtonText} TikTok`} />
      <LinkSteam buttonText={`${translatedButtonText} Steam`} />
      <LinkRiot buttonText={`${translatedButtonText} Riot`} />
      <LinkEpic buttonText={`${translatedButtonText} Epic`} />
      <LinkBattleNet buttonText={`${translatedButtonText} Battle.net`} />
    </Box>
  );
};

export { LinkedAccounts };
